import { useEffect, useRef } from "react";
import Header from "../components/common/header";
import Footer from "../components/common/footer";

const EVENTS = [
  "CONTRACT_CALL",
  "BOT_LIKE_TX",
  "GAS_SPIKE",
  "APPROVE",
  "TRANSFER",
  "SWAP",
];

export default function EventFlow() {
  const canvasRef = useRef(null);
  const particles = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight - 120;

    // 🔵 фиксированные точки
    const nodes = EVENTS.map((e, i) => ({
      id: e,
      x: canvas.width / 2 + Math.cos(i * 1.2) * 200,
      y: canvas.height / 2 + Math.sin(i * 1.2) * 200,
    }));

    let lastEvent = null;

    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // линии между нодами
      ctx.strokeStyle = "#222";
      nodes.forEach((a) => {
        nodes.forEach((b) => {
          if (a === b) return;
          ctx.beginPath();
          ctx.moveTo(a.x, a.y);
          ctx.lineTo(b.x, b.y);
          ctx.stroke();
        });
      });

      // частицы
      particles.current.forEach((p) => {
        p.t += 0.02;

        const x = p.a.x + (p.b.x - p.a.x) * p.t;
        const y = p.a.y + (p.b.y - p.a.y) * p.t;

        ctx.beginPath();
        ctx.arc(x, y, 3, 0, Math.PI * 2);
        ctx.fillStyle = "#6bc1ff";
        ctx.fill();
      });

      // удаляем завершённые
      particles.current = particles.current.filter((p) => p.t < 1);

      // ноды
      nodes.forEach((n) => {
        ctx.beginPath();
        ctx.arc(n.x, n.y, 10, 0, Math.PI * 2);
        ctx.fillStyle = "#fff";
        ctx.fill();

        ctx.fillStyle = "#aaa";
        ctx.fillText(n.id, n.x + 12, n.y);
      });

      requestAnimationFrame(draw);
    }

    draw();

    const ws = new WebSocket("wss://cryptospace.network/wallet-feed");

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        const event = msg.event;

        if (!event) return;

        const target = nodes.find((n) => n.id === event);
        if (!target) return;

        if (lastEvent) {
          const source = nodes.find((n) => n.id === lastEvent);

          if (source && target) {
            particles.current.push({
              a: source,
              b: target,
              t: 0,
            });
          }
        }

        lastEvent = event;
      } catch {}
    };

    return () => ws.close();
  }, []);

  return (
    <div style={{ background: "#000", minHeight: "100vh", color: "#fff" }}>
      <Header />

      <div style={{ padding: 16 }}>
        <h1>⚡ Event Flow</h1>
        <p style={{ color: "#aaa" }}>
          real-time behavior flow between blockchain events
        </p>
      </div>

      <canvas ref={canvasRef} />

      <Footer />
    </div>
  );
}